/**
 * Google Analytics 4 工具模块
 * 用于追踪页面浏览和自定义事件
 */

const GA_MEASUREMENT_ID = 'G-7W5463D132';

/**
 * 初始化 Google Analytics
 */
export const initGA = () => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('js', new Date());
    window.gtag('config', GA_MEASUREMENT_ID);
    console.log('✅ Google Analytics 4 已初始化');
  }
};

/**
 * 追踪页面浏览
 * @param {string} path - 页面路径
 * @param {string} title - 页面标题
 */
export const trackPageView = (path, title) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', GA_MEASUREMENT_ID, {
      page_path: path,
      page_title: title || document.title
    });
    console.log('📊 GA4 页面浏览:', path);
  }
};

/**
 * 追踪自定义事件
 * @param {string} eventName - 事件名称
 * @param {object} eventParams - 事件参数
 */
export const trackEvent = (eventName, eventParams = {}) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, eventParams);
    console.log('🎯 GA4 事件:', eventName, eventParams);
  }
};

/**
 * 追踪用户注册
 * @param {string} method - 注册方式 (如 'email', 'google')
 */
export const trackSignUp = (method = 'email') => {
  trackEvent('sign_up', {
    method: method
  });
};

/**
 * 追踪用户登入
 * @param {string} method - 登入方式 (如 'email', 'google')
 */
export const trackLogin = (method = 'email') => {
  trackEvent('login', {
    method: method
  });
};

/**
 * 追踪搜索
 * @param {string} searchTerm - 搜索词
 */
export const trackSearch = (searchTerm) => {
  trackEvent('search', {
    search_term: searchTerm
  });
};

/**
 * 追踪股票查看
 * @param {string} symbol - 股票代码
 * @param {string} page - 页面类型
 */
export const trackStockView = (symbol, page) => {
  trackEvent('view_stock', {
    stock_symbol: symbol,
    page_type: page
  });
};

/**
 * 追踪功能使用
 * @param {string} featureName - 功能名称
 * @param {object} params - 额外参数
 */
export const trackFeatureUse = (featureName, params = {}) => {
  trackEvent('use_feature', {
    feature_name: featureName,
    ...params
  });
};

export default {
  initGA,
  trackPageView,
  trackEvent,
  trackSignUp,
  trackLogin,
  trackSearch,
  trackStockView,
  trackFeatureUse
};

